import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { isEmpty } from "lodash";
import TableBase from "./TableBase";

const SelectedCondonInfo = ({
  currentAtom,
  selectedCodon,
  // eslint-disable-next-line react/prop-types
  currentProtein,
  isFullScreen,
}) => {
  if (!currentProtein) return null;
  const [relevantInformation, setRelevantInformation] = useState(null);
  const [codonRelevantInformation, setCodonRelevantInformation] =
    useState(null);
  const relevantInformationStatic = [
    "benign",
    "likely_benign",
    "uncertain_significance",
    "likely_pathogenic",
    "pathogenic",
  ];
  useEffect(() => {
    setRelevantInformation(
      relevantInformationStatic.map((info) => currentProtein[info])
    );
  }, [currentProtein]);

  useEffect(() => {
    if (!relevantInformation || !selectedCodon) return;
    setCodonRelevantInformation(
      relevantInformation.map((arrayOfPathogenicity) =>
        arrayOfPathogenicity.filter(
          (element) => element.codon.toString() === selectedCodon
        )
      )
    );
  }, [selectedCodon]);

  return (
    <div className={isFullScreen ? "tw-flex-none tw-ml-4" : ""}>
      {selectedCodon ? (
        <>
          <div className="tw-ml-4">
            <div>
              Selected residue:{" "}
              <span className="tw-font-bold">
                {currentAtom.replace(/:[a-zA-Z]+\.[^.]*$/, "")}
              </span>
            </div>
            <div className="">
              Chain:{" "}
              <span className="tw-font-bold">
                {currentAtom.split(":")[1].replace(/\..+/, "")}
              </span>
            </div>
          </div>
          {codonRelevantInformation &&
          !isEmpty(codonRelevantInformation.flat()) ? (
            <div className="tw-ml-2">
              <TableBase
                codonRelevantInformation={codonRelevantInformation}
                isFullScreen={isFullScreen}
              />
            </div>
          ) : (
            <div className="tw-ml-4">No available data for this residue</div>
          )}
        </>
      ) : (
        <div className="tw-ml-4">
          Click on a residue to see more information
        </div>
      )}
    </div>
  );
};

SelectedCondonInfo.propTypes = {
  currentAtom: PropTypes.string,
  selectedCodon: PropTypes.string,
  isFullScreen: PropTypes.bool,
};

SelectedCondonInfo.defaultProps = {
  currentAtom: null,
  selectedCodon: null,
  isFullScreen: false,
};

export default SelectedCondonInfo;
